export const variables = [
  {
    label: "transactionGrossValue",
    code: "transaction.grossValue",
    codeRegexMatcher: /^transaction.grossValue$/g,
  },
  {
    label: "totalNumberOfItemsInTransaction",
    code: "transaction.qty",
    codeRegexMatcher: /^transaction.qty$/g,
  },
  {
    label: "transactionSKUQty",
    code: "transaction.sku('').qty",
    codeRegexMatcher: /^transaction.sku+\('.*?'\).qty$/g,
    parameter: "('')",
    parameterType: "text",
    dialogTitle: "sku",
    dialogDescription: "dialogDescriptionSku",
  },
  {
    label: "grossValueOfProductsWithSpecificSku",
    code: "transaction.sku('').grossValue",
    codeRegexMatcher: /^transaction.sku+\('.*?'\).grossValue$/g,
    parameter: "('')",
    parameterType: "text",
    dialogTitle: "sku",
    dialogDescription: "dialogDescriptionSku",
  },
  {
    label: "transactionCategoryQty",
    code: "transaction.category('').qty",
    codeRegexMatcher: /^transaction.category+\('.*?'\).qty$/g,
    parameter: "('')",
    parameterType: "text",
    dialogTitle: "category",
    dialogDescription: "dialogDescriptionCategory",
  },
  {
    label: "grossValueOfProductsFromSpecificCategory",
    code: "transaction.category('').grossValue",
    codeRegexMatcher: /^transaction.category+\('.*?'\).grossValue$/g,
    parameter: "('')",
    parameterType: "text",
    dialogTitle: "category",
    dialogDescription: "dialogDescriptionCategory",
  },
  {
    label: "transactionBrandQty",
    code: "transaction.maker('').qty",
    codeRegexMatcher: /^transaction.maker+\('.*?'\).qty$/g,
    parameter: "('')",
    parameterType: "text",
    dialogTitle: "brand",
    dialogDescription: "dialogDescriptionBrand",
  },
  {
    label: "grossValueOfProductsFromSpecificBrand",
    code: "transaction.maker('').grossValue",
    codeRegexMatcher: /^transaction.maker+\('.*?'\).grossValue$/g,
    parameter: "('')",
    parameterType: "text",
    dialogTitle: "brand",
    dialogDescription: "dialogDescriptionBrand",
  },
  {
    label: "totalNumberOfProductsWithSpecificCustomAttribute",
    code: "transaction.itemLabel('').qty",
    codeRegexMatcher: /^transaction.itemLabel+\('.*?'\).qty$/g,
    parameter: "('')",
    parameterType: "text",
    dialogTitle: "customAttribute",
    dialogDescription: "dialogDescriptionCustomAttribute",
  },
  {
    label: "grossValueOfProductsWithSpecificCustomAttributes",
    code: "transaction.itemLabel('').grossValue",
    codeRegexMatcher: /^transaction.itemLabel+\('.*?'\).grossValue$/g,
    parameter: "('')",
    parameterType: "text",
    dialogTitle: "customAttribute",
    dialogDescription: "dialogDescriptionCustomAttribute",
  },
];
